import { SET_PROJECTS_BY_ID } from "../../../constants";

export const setProjectById = (getProjectsById: any = {}) => ({
  type: SET_PROJECTS_BY_ID,
  payload: getProjectsById,
});
